import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import { parseTime, paramsToFormData, isSystem } from '@/utils/custom';
import vueEsign from 'vue-esign'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { VueJsonp } from 'vue-jsonp'
import 'amfe-flexible'

Vue.use(Vant)
Vue.use(vueEsign)
Vue.use(VueAxios, axios)
Vue.use(VueJsonp)

// 全局方法挂载
Vue.prototype.parseTime = parseTime
Vue.prototype.paramsToFormData = paramsToFormData
Vue.prototype.isSystem = isSystem
Vue.prototype.VueJsonp = VueJsonp

Vue.config.productionTip = false

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
